<template>
<div id="gt">
	
</div>
</template>
<script>
import gt from '../../../static/js/gt.js'
export default {
	data () {
		return {
			gt:undefined,
		}
	},
	mounted () {
		this.$nextTick(()=>{
			this.$postNo('/gt3/register.admin',res=>{
				gt({
				    gt: res.data.gt,
				    challenge: res.data.challenge,
				    product: "popup", // 产品形式，包括：float，embed，popup。注意只对PC版验证码有效
				    offline: !res.data.success, // 表示用户后台检测极验服务器是否宕机，一般不需要关注
				    // 更多配置参数请参见：http://www.geetest.com/install/sections/idx-client-sdk.html#config
				    width:'100%'
				}, this.handlerPopup.bind(this));
			})
		})
	},
	methods:{
		handlerPopup (captchaObj) {
			this.gt = captchaObj;
		    // 成功的回调
		    let that = this;
	        captchaObj.onSuccess(function () {
	            that.$emit('on-success',captchaObj.getValidate())
	        });
	        // 将验证码加到id为captcha的元素里
	        captchaObj.appendTo("#gt");
		},
		reset () {
			this.gt.reset()
			this.$emit('on-success')
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/common/gt.vue